export default __webpack_public_path__ + "static/media/add-member.9a384ce5.svg";